
export function appendUrlParam(url, key, value) {
    key = encodeURIComponent(key.toString());
    value = encodeURIComponent(value.toString());
    return `${url}${url.includes('?')?'&':'?'}${key}=${value}`;
}

export function useActiveTab(path) {
    if (path.startsWith('/u/')) return "profile";
    if (path.startsWith('/communities')) return "communities";
    if (path.startsWith('/c/all') || path.startsWith('/c/trending')) return "trending";
    if (path.startsWith('/message')) return "messages";
    return "home";
}
